import Vue from "vue";
import axios from "axios";
import {MyStorage} from "@/js/utils";
import store from "@/store";
import router from "@/router"


axios.defaults.withCredentials = true;
// 设置超时时间
axios.defaults.timeout = 60000;


// 检查CODE值
function checkStatus(res) {
  if(!res){
    throw new Error("Request failed")
  }
  if (res && res.status !== 200 && res.message) {
    throw new Error(res.message)
  }
  if (res.data.status && res.data.status !==200){
    if (res.data.status === 501){
      console.log("token校验失败");
      store.dispatch('updateLoggedIn', false);
      router.push({path:"/login"})
    }
    throw new Error(res.data.message)
  }
  return res.data;
}

// 错误处理
function errorHandler(err) {
  if(err && err.message){
    Vue.prototype.$loading.hide()
    Vue.prototype.$toast.show(err.message)
  }
}

export default {
  get(url, params = {}, responseType) {
    if (!url) return;
    return axios({
      method: "get",
      url,
      params,
      responseType: responseType || "",
      headers: {
        userToken: MyStorage.getItem("userToken"),
        "Content-Type":"application/json"
      },
    })
      .then(checkStatus)
      .catch((err) => {
        console.log("aixos错误：",err);
        errorHandler(err);
      });
  },
  post(url, data = {}) {
    if (!url) return;
    return axios({
      method: "post",
      url,
      data,
      headers: {
        userToken: MyStorage.getItem("userToken"),
      },
    })
      .then(checkStatus)
      .catch((err) => {
        errorHandler(err);
      });
  },
};